import { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export function LoginPage() {
  const { isAuthenticated, isLoading, login } = useAuth();
  const location = useLocation();
  const startedRedirect = useRef(false);

  const from = (location.state as { from?: { pathname: string; search: string } } | null)?.from;
  const returnUrl = from ? `${from.pathname}${from.search}` : '/';

  useEffect(() => {
    if (isAuthenticated || isLoading || startedRedirect.current)
      return;

    startedRedirect.current = true;
    void login(returnUrl).catch((error: unknown) => {
      console.error('Sign in redirect failed:', error);
      startedRedirect.current = false;
    });
  }, [isAuthenticated, isLoading, login, returnUrl]);

  if (isAuthenticated) {
    return <Navigate to={returnUrl} replace />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto" />
        <p className="mt-4 text-gray-600">Signing in…</p>
      </div>
    </div>
  );
}
